import request from '../../request/request.js'
//获取其他公司
export const GetOtherCompanyAPI = () => request.get(`/recommend/otherCompany`)
//获取智能职业推荐
export const IntellRecommendAPI = () => request.get('/recommend/recoCareer');

